/** @type {import('../help-index.js').HelpSidebarItem} */
export const SETTINGS_USERS_LIST_ITEM = {
  id: 'sub_nav_0',
  screenId: 'settings-users-list',
  label: 'Usuarios',
  description: 'Alta, edición y baja de cuentas de acceso.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro: 'Administrás quién puede ingresar al sistema: nombre de usuario, contraseña, datos personales y si está activo.',
      },
      {
        title: 'Paso 1 — Lista',
        bullets: [
          'Interruptor «Solo activos».',
          'Columnas: ID, Usuario, Nombre, DNI, Acciones.',
          'Lápiz — editar. Ojo — ver detalle. Botón + — nuevo usuario.',
        ],
      },
      {
        title: 'Paso 2 — Nuevo usuario',
        fields: [
          { label: 'Usuario / Contraseña', description: 'Obligatorios para el login.' },
          { label: 'Nombre / DNI', description: 'Opcionales.' },
          { label: 'Teléfonos / Correos', description: 'Filas opcionales con descripción.' },
        ],
        paragraphs: ['El usuario nuevo recibe permiso general de lectura; ajustalo en «Autorización de Usuarios».'],
      },
      {
        title: 'Paso 3 — Editar',
        paragraphs: ['Podés cambiar nombre, DNI, contactos, contraseña y activar/desactivar el usuario.'],
      },
    ],
  },
}

/** @type {import('../help-index.js').HelpSidebarItem} */
export const SETTINGS_USERS_AUTH_ITEM = {
  id: 'sub_nav_1',
  screenId: 'settings-users-auth',
  label: 'Autorización de usuarios',
  description: 'Permisos por módulo (leer, crear, modificar, borrar).',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro: 'Definís qué puede hacer cada usuario en cada área del sistema (Ventas, Finanzas, Laboral, etc.): ver, crear, editar o eliminar.',
      },
      {
        title: 'Paso 1 — Elegir usuario',
        bullets: [
          'Lista de usuarios activos (o todos si desmarcás el filtro).',
          'Lápiz — editar permisos. Ojo — solo ver (sin cambiar).',
        ],
      },
      {
        title: 'Paso 2 — Árbol de permisos',
        bullets: [
          'Expandí cada módulo del menú.',
          'Marcá letras: r = leer, c = crear, u = modificar, d = borrar, t = test (si aplica).',
          '«Expandir todo» / «Contraer todo» para navegar más rápido.',
          'Guardá los cambios al terminar.',
        ],
      },
    ],
  },
}

/** @type {import('../help-index.js').HelpSidebarItem} */
export const SETTINGS_USERS_ACCESS_ITEM = {
  id: 'sub_nav_2',
  screenId: 'settings-users-access',
  label: 'Acceso de los usuarios',
  description: 'Restricción por caja, banco, terminal, etc.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro: 'Limitás a qué recursos concretos accede cada usuario aunque tenga permiso en un módulo: por ejemplo solo ciertas cajas o cuentas bancarias.',
      },
      {
        title: 'Paso 1 — Elegir usuario',
        paragraphs: ['Misma lista que en Usuarios. Lápiz para configurar accesos.'],
      },
      {
        title: 'Paso 2 — Recursos',
        bullets: [
          'Bloques por tipo: cajas, bancos, terminales de venta, etc.',
          'En cada fila elegís el nivel de acceso permitido (según las opciones del recurso).',
          'Guardá al finalizar.',
        ],
      },
    ],
  },
}
